import React, { useState } from "react";
import * as i18n from "util/i18n";
import { Col, Row } from "react-bootstrap";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import Action from "pages/_components/Action";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { bool } from "prop-types";
import { actions as echeckActions } from "reducers/echecks";
import { useLocation } from "react-router-dom";
import Notification from "pages/_components/Notification";
import { useTransaction } from "hooks/useTransactions";
import { isIOS } from "react-device-detect";
import SolicitAvalSummaryBody from "./Summary";

const SolicitAvalTransactionPage = ({ isDesktop }) => {
    const { state = {} } = useLocation();
    const { isFlowComplete = false } = state;
    const formatTransactionAval = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        "/echecks/aval/solicit/sumary",
        echeckActions.setAvalDetail,
        echeckActions.cleanEcheckTicket,
        formatTransactionAval,
    );
    const { componentRef, handlePrint, handlePrintMobile, mobileRef, handleShareMobile } = useReactPrint(
        "echeq.request.aval.echeq",
        id,
        "requestEcheqAval",
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const { isFinished, isBackoffice } = status;
    const backLinkTo = isFlowComplete ? "/echecks" : "";
    const handleDownloadMobile = async () => {
        await setShowMoreData(true);
        return handlePrintMobile();
    };
    const handleDownloadDesktop = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };
    return (
        <>
            <Notification scopeToShow="requestEcheqAval" />
            {!isBackoffice && (
                <ResponsiveHeader ticket metaTitle="echeq.request.aval.echeq" backLinkTo={backLinkTo}>
                    {isFinished && (
                        <>
                            <DesktopButtons>
                                <Button
                                    className="btn btn-outline"
                                    image="images/download.svg"
                                    label="global.download"
                                    onClick={handleDownloadDesktop}
                                    block={false}
                                />
                            </DesktopButtons>
                            <MobileButtons
                                image={
                                    isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"
                                }>
                                <Action labelKey="global.download" handleClick={handleDownloadMobile} />
                                <Action labelKey="global.share" handleClick={handleShareMobile} />
                            </MobileButtons>
                        </>
                    )}
                </ResponsiveHeader>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="echeq.request.aval.echeq" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <SolicitAvalSummaryBody
                                        ticket
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                            <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                />
                            </Col>
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

SolicitAvalTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default SolicitAvalTransactionPage;
